'use strict';

/**
  * A Sequelize module that contains the sequelize entry point.
  *
  * @module sequelize
  */

/** Exports the sequelize entry point. */
module.exports = require('./sequelize');
